import axios from 'axios';
import { defineStore } from 'pinia';
import { useStoreCountry } from '../client/country';
import type { IRequestOptions } from '~/types/transport/requestOptions';

export const bitBack = defineStore('transportBitBack', {
  actions: {
    async get(requestOptions: IRequestOptions) {
      try {
        const host = useRuntimeConfig().public.BIT_BACKEND_HOST;
        const url = `${host}${requestOptions.url || ''}`;

        const response = await axios.get(url, {
          withCredentials: !!requestOptions.withCredentials,
          headers: { geo: useStoreCountry().country },
        });

        return response.data || null;
      } catch (e: any) {
        console.error(e);
        return null;
      }
    },
  },
});
